import { render, staticRenderFns } from "./garden.vue?vue&type=template&id=305bca10&scoped=true"
import script from "./garden.vue?vue&type=script&lang=js"
export * from "./garden.vue?vue&type=script&lang=js"
import style0 from "./garden.vue?vue&type=style&index=0&id=305bca10&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "305bca10",
  null
  
)

export default component.exports